/** Nach fehlgeschlagenem getRedirectResult → Login zeigt Meldung einmalig */

const KEY = 'mail-aid:authRedirectError.v1';

export function stashAuthRedirectErrorCode(code) {
  try {
    if (code) sessionStorage.setItem(KEY, String(code));
  } catch {
    /* ignore */
  }
}

export function consumeAuthRedirectErrorCode() {
  try {
    const v = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return v || '';
  } catch {
    return '';
  }
}
